
import {debounceTime} from 'rxjs/operators';
import {Component, Output, EventEmitter, Input, ViewEncapsulation} from '@angular/core';
import { FormControl } from '@angular/forms';
import { FlatTreeControl } from '@angular/cdk/tree';
import { of as observableOf, Subscription} from 'rxjs';
import { Folder, FourDService } from '4d-mapper';
import { DynamicDatabase,DynamicDataSource,DynamicFlatNode } from './treeview'
import {MainService} from '../main/main.service';
import { MatDialog } from '@angular/material';
import { NotificationDialog, NotificationDialogData } from './dialogs/notification-dialog';
import { PUBLIC_FOLDER_CHECK } from './global';

@Component({
  selector: 'explorer-tree',
  templateUrl: './explorer-tree.component.html',
  styleUrls:['./explorer-tree.component.scss'],
  providers: [DynamicDatabase],
  encapsulation: ViewEncapsulation.None
})

export class ExplorerTreeComponent{

  searchCont = new FormControl()

  subs:Subscription[] = []

  searchQ:string

  treeControl: FlatTreeControl<DynamicFlatNode>;

  dataSource: DynamicDataSource;

  selectedFolder:Folder
  selectedRoot:Folder

  @Input()
  baseQuery:any

  @Input()
  moreMenu:any

  @Input()
  showDelete:boolean


  @Output()
  folderSelected = new EventEmitter<Folder>()

  @Output()
  rootSelect = new EventEmitter<Folder>()

  @Output()
  folderDelete = new EventEmitter<Folder>()

  @Output()
  folderCount = new EventEmitter<number>()

  currentNode:DynamicFlatNode

  getLevel = (node: DynamicFlatNode) => node.level;

  isExpandable = (node: DynamicFlatNode) => node.expandable;

  hasChild = (_: number, _nodeData: DynamicFlatNode) => _nodeData.expandable;

  counter:number = 0;

  constructor(private database: DynamicDatabase,private fourD:FourDService, private mainService: MainService, public dialog: MatDialog){

    // console.log ( 'explorer-tree constructor' );

    // when search / filters change
    this.subs.push(this.searchCont.valueChanges.pipe(debounceTime(1000)).subscribe(s => {
      // console.log ( 'explorer-tree searchChange -> refresh' );
      this.searchQ = s;
      this.refresh(s);
    }));

  }
  ngOnInit(){

    // console.log ( 'explorer-tree ngOnInit -> refresh' );

    // first, refresh
    this.refresh(null);

    // on search? (@alex)
    this.mainService.searchFilesFolder.subscribe(value => {
      // console.log ( 'explorer-tree searchFilesFolder -> refresh' );
      this.refresh(value);
    });
  }
  ngAfterViewInit(){
  }

  // what defines a change for this to kick in? (@alex)
  ngOnChanges(a){
    
    if(a.baseQuery){
      // console.log ( 'explorer-tree ngOnChanges -> refresh' );
      this.refresh(null)

    }
  }

  refresh (search) {

    // console.log ( 'explorer-tree **refresh**', this.subs );

    this.database.baseQuery = this.baseQuery;
    this.treeControl = null;

    // why the 300ms delay here? (@alex)
    setTimeout( () => {

      // this seems odd; adding new subscribes with every refresh? (@alex)
      this.subs.push(this.database.initialData(search).subscribe(s => {

        // console.log ( 'explorer-tree subscribe', s);

        this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.isExpandable);
        this.treeControl.expansionModel.changed.subscribe(s =>{
        //  s.added.forEach(a => this.dataSource.data.filter(d => d != a).forEach(d => this.treeControl.collapse(d)))
        })

        // console.log ( 'explorer-tree new DynamicDataSource', s);

        this.dataSource = new DynamicDataSource(this.treeControl, this.database);
        this.dataSource.data = s;
        
        // Emit event to notify count of folders
        this.folderCount.emit(s ? s.length : 0);

        setTimeout(() => {
          var f = this.dataSource.data.find(d => d.item['root'] == 'myFiles')
          this.treeControl.expand(f)
          this.selectedRoot = f.item
        },200)
        this.dataSource.filesChange.subscribe(s => {
          !this.selectedFolder ? this.folderSelected.emit(this.selectedFolder) : '';
        })
      }));

    } ,200);

  }

  selectFolder(f:Folder,n:DynamicFlatNode){
    
    // New requirement https://4dlink.atlassian.net/browse/DM4-287.
    // Showing pop-up for "Public Samples" folder.
    if (f.uid == 'public_global') {
      var publicFolderCheck = localStorage.getItem( PUBLIC_FOLDER_CHECK )
      if(publicFolderCheck != this.fourD.domainConfig.public_folder_check) {
        // Show popup
        let dialogRef = this.dialog.open<any,NotificationDialogData>(NotificationDialog, {
          width: '60%',
          data: {
            title:'DIALOG.PUBLIC_FOLDER_TITLE',
            text: this.fourD.domainConfig.public_folder_text,
            checkboxText: 'DIALOG.PUBLIC_FOLDER_CHECKBOX',
            posBtn: 'GENERIC.OK'
          }
        })
        dialogRef.afterClosed().subscribe(dialogData => {
          // If user selected to stop displaying thios check store it on the users local storage.
          if (dialogData.checkboxValue) {
            localStorage.setItem( PUBLIC_FOLDER_CHECK, this.fourD.domainConfig.public_folder_check)
          }
        })
      }
    }
    /******************************************************* */
    this.currentNode = n
    this.selectedFolder = f;
    if(f['root']){
      this.selectedRoot = f
      this.rootSelect.emit(f)
    }

    this.folderSelected.emit(this.selectedFolder)

    this.dataSource.data.filter(d => d.level == (n?n.level:0) && n != d && this.treeControl.isExpanded(d)).forEach(d => this.treeControl.collapse(d))
  }
  openFolder(f:Folder){
    this.counter=0;
    var v = this.dataSource.data.find(d => d.item == f)
    if(v)
      this.dataSource.toggleNode(v,true)
  }
  ngOnDestroy(){
    this.subs.forEach(s => s.unsubscribe())
  }

  getNodeState( node:DynamicFlatNode ) {
    return {
      isOpen:       this.treeControl.isExpanded(node),
      isForJob:     node.item.forJobBatch ? true : false,
      isForProject: node.item.forProject ? true : false,
      isForScene:   node.item.forScene ? true : false
    };
  }

  getIcon ( node:DynamicFlatNode ) {

    let state = this.getNodeState(node);

    if ( this.counter++ == 1 ) {
      console.log('@@@', node);
    }

    if ( state.isForProject ) {
      if ( state.isOpen ) { return 'box-open'; } else { return 'box'; }
    } else if ( state.isForJob ) {
      if ( state.isOpen ) { return 'envelope-open'; } else { return 'envelope'; }
    } else if ( state.isForScene ) {
      if ( state.isOpen ) { return 'door-open'; } else { return 'door-closed'; }
    }

    if ( state.isOpen ) {
      return ['far','folder-open'];
    } else {
      return ['fas','folder'];
    }
  }

  getType ( node:DynamicFlatNode ) {

    let state = this.getNodeState(node);

    if ( state.isForProject ) {
      return 'project';
    } else if ( state.isForJob ) {
      return 'job';
    } else if ( state.isForScene ) {
      return 'scene';
    }

    return 'folder';
  }

  getCount ( node:DynamicFlatNode ) {
    let folders:number = node.item['folder_count'];
    let files:number = node.item['file_count'];
    let total = folders + files;
    if ( total > 0 ) {
      return '('+total+')';
    }
    return '';
  }

}




